import { browserHistory } from 'react-router';
import _ from 'lodash';
import * as alasql from 'alasql';

import constants from './constants';
import apiConstants from '../api/constants/api-constants';
import clientsConstants from '../app/main/clients/constants/clients-constants';

alasql['private'].externalXlsxLib = require('xlsx');

class Helpers {
  static formAxiosObject(method, endpoint, data, params, urlParams, headers) {
    if (urlParams) {
      for (let key in urlParams) {
        endpoint += `/${urlParams[key]}`;
      }
    }

    const axiosObject = {
      url: `${constants.api_url}${endpoint}`,
      method,
    };

    if (headers) {
      axiosObject.headers = headers;
    }

    if (data && (method === apiConstants.request_methods.post || method === apiConstants.request_methods.put || method === apiConstants.request_methods.delete)) {
      axiosObject.data = data;
    }

    if (params && method === apiConstants.request_methods.get) {
      axiosObject.params = params;
    }

    return axiosObject;
  }

  static goToPage(url) {
    browserHistory.push(url);
  }

  static validateForm(values, fields) {
    let errors = {};

    for (let i = 0; i < fields.length; i++) {
      if (fields[i].match_validate && values[fields[i].name] !== values[fields[i].match_field]) {
        errors[fields[i].name] = fields[i].match_error;
      }

      if (values[fields[i].name] && fields[i].email_validate && !constants.email_regex.test(values[fields[i].name])) {
        errors[fields[i].name] = 'COMMON.EMAIL_VALID';
      }

      if (values[fields[i].name] && fields[i].password_validate && !constants.password_regex.test(values[fields[i].name])) {
        errors[fields[i].name] = 'COMMON.PASSWORD_VALID';
      }

      if (
        values[fields[i].name] &&
        fields[i].username_validate &&
        !constants.username_regex.test(values[fields[i].name]) &&
        values[fields[i].skip_username_validation_field] !== fields[i].skip_username_validation_value
      ) {
        errors[fields[i].name] = 'COMMON.USERNAME_VALID';
      }

      if (fields[i].required && !values[fields[i].name]) {
        errors[fields[i].name] = fields[i].required_error || 'COMMON.REQUIRED_FIELD';
      }
    }

    return errors;
  }
  
  static getBanners(type, tab, bannerTypeObj, imageType) {
    let banners = [
      {
        url: `${constants.partners_bucket}banners/${type}/${tab || 'en'}/160x600_LAYOUT_.${imageType || 'png'}`,
        width: 160,
        height: 600,
      },
      {
        url: `${constants.partners_bucket}banners/${type}/${tab || 'en'}/300x250_LAYOUT_.${imageType || 'png'}`,
        width: 300,
        height: 250,
      },
      {
        url: `${constants.partners_bucket}banners/${type}/${tab || 'en'}/300x600_LAYOUT_.${imageType || 'png'}`,
        width: 300,
        height: 600,
      },
      {
        url: `${constants.partners_bucket}banners/${type}/${tab || 'en'}/728x90_LAYOUT_.${imageType || 'png'}`,
        width: 728,
        height: 90,
      },
      {
        url: `${constants.partners_bucket}banners/${type}/${tab || 'en'}/970x90_LAYOUT_.${imageType || 'png'}`,
        width: 970,
        height: 90,
      },
      {
        url: `${constants.partners_bucket}banners/${type}/${tab || 'en'}/970x250_LAYOUT_.${imageType || 'png'}`,
        width: 970,
        height: 250,
      },
      {
        url: `${constants.partners_bucket}banners/${type}/${tab || 'en'}/1080x1080_LAYOUT_.${imageType || 'png'}`,
        width: 1080,
        height: 1080,
      },
    ];

    if (bannerTypeObj) {
      let finalBanners = [];

      _.forEach(banners, banner => {
        if (bannerTypeObj.widths.indexOf(banner.width) > -1 && bannerTypeObj.heights.indexOf(banner.height) > -1) {
          if (bannerTypeObj.layouts) {
            _.forEach(bannerTypeObj.layouts[tab], layout => {
              const newBanner = Object.assign({}, banner);
              newBanner.url = newBanner.url.replace('_LAYOUT_', layout);
              finalBanners.push(newBanner);
            });
            banner.url = banner.url.replace('_LAYOUT_', '');
            finalBanners.push(banner);
          } else {
            banner.url = banner.url.replace('_LAYOUT_', '');
            finalBanners.push(banner);
          }
        }
      });

      return finalBanners;
    }

    _.forEach(banners, banner => {
      banner.url = banner.url.replace('_LAYOUT_', '');
    });

    return banners;
  }

  static getUrlHtml(url, anchor) {
    return `<a href="${url}" target="_blank">${anchor || url}</a>`;
  }

  static getBannerHtml(url, banner) {
    return `<a href="${url}" target="_blank"><img src="${banner.url}" alt="NAGA Banner" class="banner-preview" height="${banner.height}" width="${banner.width}" /></a>`;
  }

  static getVideoUrl(url, videoUrl) {
    return `<a href="${url}" target="_blank"><iframe src="${videoUrl}" frameborder="0" allowfullscreen title="NAGA Video" /></a>`;
  }

  static copyToClipboard(text) {
    let textField = document.createElement('textarea');
    textField.innerText = text;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
  }

  static generateRandomString(length) {
    let result = '';

    for (let i = 0; i < length; i++) {
      result += constants.random_string_chars.charAt(Math.floor(Math.random() * constants.random_string_chars.length));
    }

    return result;
  }

  static export(filename, data, exportType, tableSelector) {
    switch (exportType) {
      case clientsConstants.export_buttons.csv.type:
        this.exportToCsv(filename, data);
        break;
      case clientsConstants.export_buttons.xlsx.type:
        this.exportToXlsx(filename, data);
        break;
      case clientsConstants.export_buttons.html.type:
        this.exportToHtml(tableSelector);
        break;
      default:
        this.printTable(tableSelector);
        break;
    }
  }

  static exportToCsv(filename, dataArray) {
    let data, link;

    let csv = this.convertToCsv({
      data: dataArray,
    });

    if (csv === null) return;

    if (!csv.match(/^data:text\/csv/i)) {
      csv = 'data:text/csv;charset=utf-8,' + csv;
    }

    data = encodeURI(csv);

    filename += '.csv';

    link = document.createElement('a');
    link.setAttribute('href', data);
    link.setAttribute('download', filename);
    link.click();
  }

  static convertToCsv(args) {
    let result, ctr, keys, columnDelimiter, lineDelimiter, data;

    data = args.data || null;
    if (data === null || !data.length) {
      return null;
    }

    columnDelimiter = args.columnDelimiter || ',';
    lineDelimiter = args.lineDelimiter || '\n';

    keys = Object.keys(data[0]);

    result = '';
    result += keys.join(columnDelimiter);
    result += lineDelimiter;

    data.forEach(function(item) {
      ctr = 0;
      keys.forEach(function(key) {
        if (ctr > 0) result += columnDelimiter;

        result += item[key];
        ctr++;
      });
      result += lineDelimiter;
    });

    return result;
  }

  static exportToXlsx(filename, data) {
    alasql
      .promise(`SELECT * INTO XLSX("${filename}.xlsx",{headers:true}) FROM ?`, [data])
      .then(function(result) {})
      .catch(function(err) {
        console.log('Error:', err);
      });
  }

  static exportToHtml(selector) {
    const table = this.getOuterHtml(selector);

    if (table) {
      const myWindow = window.open();
      myWindow.document.write(table);
    }
  }

  static getOuterHtml(selector, shouldHideElements) {
    const table = document.getElementsByClassName(selector);
    if (table && table[0]) {
      return table[0].outerHTML;
    }
    return '';
  }

  static printTable(selector) {
    const table = this.getOuterHtml(selector);

    if (table) {
      const myWindow = window.open('', 'print', 'width=750,height=650,top=50,left=50,toolbars=no,scrollbars=yes,status=no,resizable=yes');
      myWindow.document.writeln(table);
      myWindow.document.close();
      myWindow.focus();
      myWindow.print();
      myWindow.close();
    }
  }

  static detectBrowser() {
    if ((navigator.userAgent.indexOf('Opera') || navigator.userAgent.indexOf('OPR')) !== -1) {
      return constants.browsers.opera;
    }

    if (navigator.userAgent.indexOf('Chrome') !== -1) {
      return constants.browsers.chrome;
    }

    if (navigator.userAgent.indexOf('Safari') !== -1) {
      return constants.browsers.safari;
    }

    if (navigator.userAgent.indexOf('Firefox') !== -1) {
      return constants.browsers.firefox;
    }

    if (navigator.userAgent.indexOf('MSIE') !== -1 || !!document.documentMode === true) {
      return constants.browsers.ie;
    }

    return 'unknown';
  }

  static formUrl(site, queryParams, lang) {
    return `${site.base_url}${site.is_language_required && lang && lang !== 'en' ? `${lang}/` : ''}${site.additional_data && site.additional_data.query_params ? '?' : ''}${this.formQueryString(
      site.additional_data,
      queryParams
    )}`;
  }

  static formQueryString(data, queryParams) {
    let result = '';

    if (data && data.query_params) {
      for (let i = 0; i < data.query_params.length; i++) {
        result += `${i === 0 ? '' : '&'}${data.query_params[i].parameter}=${queryParams[data.query_params[i].parameter] || data.query_params[i].default_value || ''}`;
      }
    }

    return result;
  }

  static getUserType(profile) {
    if (profile) {
      const type = profile.user_type;
      const userType = _.find(constants.user_types, { value: type }) || {};
      return userType.text || '';
    } else return '';
  }
}

export default Helpers;



// WEBPACK FOOTER //
// ./src/common/helpers.js